const { NODE_ENV = "production", REACT_APP_WORDPRESS_URL = "" } = process.env;
const baseURL = NODE_ENV === "production" ? "" : REACT_APP_WORDPRESS_URL;

const endpoints = {
	advisorLogin: {
		url: `${baseURL}/wp-json/midtown-memberships/advisor-login`,
		requestMethod: "POST",
	},
	step0: {
		url: `${baseURL}/wp-json/midtown-memberships/get-clubs`,
		requestMethod: "GET",
	},
	step1: {
		url: `${baseURL}/wp-json/midtown-memberships/step-1`,
		requestMethod: "POST",
	},
	step2: {
		url: `${baseURL}/wp-json/midtown-memberships/step-2`,
		requestMethod: "POST",
	},
	step3: {
		url: `${baseURL}/wp-json/midtown-memberships/step-3`,
		requestMethod: "POST",
	},
	step4: {
		url: `${baseURL}/wp-json/midtown-memberships/step-4`,
		requestMethod: "POST",
	},
	validateZip: {
		url: `${baseURL}/wp-json/midtown-memberships/validate-zip`,
		requestMethod: "POST",
	},
	getMembershipInfo: {
		url: `${baseURL}/wp-json/midtown-memberships/get-membership-details`,
		requestMethod: "POST",
	},
	memberLookup: {
		url: `${baseURL}/wp-json/midtown-memberships/member-lookup`,
		requestMethod: "POST",
	},
	createHubspotContact: {
		url: `${baseURL}/wp-json/midtown-memberships/create-hubspot-contact`,
		requestMethod: "POST",
	},
	getContact: {
		url: `${baseURL}/wp-json/midtown-memberships/get-contact`,
		requestMethod: "POST",
	},
	validateUsername: {
		url: `${baseURL}/wp-json/midtown-memberships/validate-username`,
		requestMethod: "POST",
	},
	createMember: {
		url: `${baseURL}/wp-json/midtown-memberships/create-member`,
		requestMethod: "POST",
	},
	finalizeMember: {
		url: `${baseURL}/wp-json/midtown-memberships/finalize-member`,
		requestMethod: "POST",
	},
};

export default endpoints;
